const getters = {
  isLoading: state => state.isLoading,
  isGatesLoading: state => state.isGatesLoading,
  isDocksLoading: state => state.isDocksLoading,
  show: state => state.depot,
  gates: state => state.gates,
  docks: state => state.docks,
  all: state => state.all,
  filter: state => state.filter,
  isPaginating: state => state.isPaginating,
  hasEmpty: state => state.hasEmpty,
};

export default getters;
